import React from 'react';
import {Link} from "react-router-dom";
import {useSiteContentValue} from "../../context/SiteContentContext";
import './announcement-bar.css';

// The bar is opt-in twice over: an admin has to publish text AND tick "מוצג
// באתר". The shipped defaults have enabled:false, so it never self-shows.
const AnnouncementBar: React.FC = () => {
    const {content} = useSiteContentValue();
    const {text, enabled} = content.announcement;

    if (!enabled || !text.trim()) {
        return null;
    }

    return (
        <div className="lnk-announce" dir="rtl" role="region" aria-label="הודעה">
            <span className="lnk-announce__chip">חדש</span>
            <span className="lnk-announce__text">{text}</span>
            {/* Router link, not a raw hash mutation - the destination is a real
                route and must not reload the app. */}
            <Link className="lnk-announce__link" to="/ai-mentions">גלו עוד ›</Link>
        </div>
    );
};

export default AnnouncementBar;
